/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-19 16:35:50
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-05 11:21:52
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorProductSearch/FeaturedProduct/index.tsx
 */
import React from 'react';
import css from './css.less';

import { Collapse } from '@/src/components/Antd';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import FeaturedProductsSection from 'src/constrains/SalesChannelPreviewPageComponents/FeaturedProductsSection';
import GeneralCollapseContent from 'src/constrains/SalesChannelPreviewPageComponents/GeneralCollapseContent';
import GeneralCollapseHeader from 'src/constrains/SalesChannelPreviewPageComponents/GeneralCollapseHeader';
import GeneralCollapseWrapper from 'src/constrains/SalesChannelPreviewPageComponents/GeneralCollapseWrapper';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getGeneralFeaturedProduct,
  onCollapseOpen,
  onFeaturedProductChange,
} from '../slice';
const FeaturedProducts = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const _id = EnumCollapseId.featuredProducts;
  const { isPrimary, withoutCollapse, collapseOpenDefault } = props;
  const _d = useDispatch();
  const h = useHistory();
  const { saleChannelUuid, contentUuid }: any = useParams();
  const onEdit = () => {
    h.push(
      `/salesChannel/editor/content/promotion/${saleChannelUuid}/${contentUuid}`,
    );
  };
  const { titleTextColor, enabled } = useSelector(getGeneralFeaturedProduct());
  const handleOnColorChange = (e) => {
    _d(onFeaturedProductChange(e));
  };
  const handleOnCollapseOpen = (status) => {
    const _g = status ? [_id] : [];
    _d(onCollapseOpen({ idArr: _g }));
  };
  const _open = withoutCollapse || useSelector(getCollapseOpenStatus(_id));

  const renderTitle = () => {
    return (
      <GeneralCollapseHeader
        content={getI18n('salesChannelContent.index.featuredProducts')}
      />
    );
  };
  return enabled ? (
    <GeneralCollapseWrapper>
      <Collapse
        id={_id}
        open={_open}
        title={renderTitle()}
        withoutCollapse={withoutCollapse}
        content={
          <GeneralCollapseContent className={css.overWriteContent}>
            <FeaturedProductsSection
              handleOnColorChange={handleOnColorChange}
              colour={titleTextColor}
              onClick={onEdit}
              disableColorPicker={!isPrimary}
              withoutCollapse={withoutCollapse}
            />
          </GeneralCollapseContent>
        }
        clickToExpand
        //open={true}
        expandOffset={collapseOpenDefault ? 0 : 12}
        onClickTrigger={handleOnCollapseOpen}
      />
    </GeneralCollapseWrapper>
  ) : null;
};
export default FeaturedProducts;
